import { render, staticRenderFns } from "./ReplacementRuleConfigTable.vue?vue&type=template&id=047bd2e4"
import script from "./ReplacementRuleConfigTable.vue?vue&type=script&lang=js"
export * from "./ReplacementRuleConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports